import { render, staticRenderFns } from "./IconSvgACTFLCentral.vue?vue&type=template&id=72a12f04&scoped=true&"
import script from "./IconSvgACTFLCentral.vue?vue&type=script&lang=js&"
export * from "./IconSvgACTFLCentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a12f04",
  null
  
)

export default component.exports